import {UserType} from '../../../../../backend/enums/user-type';
import {EntityInfo} from '../../../../../backend/interfaces/entity-info';
import {EntityReportsRepository} from '../../../../../repositories/entity-reports';
import {createUsersFilters} from '../../../../../components/users-filters/users-filters-utils';

export type ExportSeniorsReportData = {
  entity: EntityInfo;
  reportData: any[];
};

export async function exportSeniorsGetReportData({
  entity,
  rawFilters,
}: {
  entity?: EntityInfo;
  rawFilters?: string;
}): Promise<ExportSeniorsReportData | null> {
  if (!entity) {
    return null;
  }

  const reportFilters = createSeniorsReportFilters(rawFilters);

  const reportData = await EntityReportsRepository.instance.affliations({
    entityId: entity.id,
    body: {
      types: [UserType.Senior],
      socialResponses: reportFilters.socialResponseIds,
      users: {
        isActive: reportFilters.usersActiveStatus,
        propertiesToInclude: [
          'email',
          'birthday',
          'phoneNumber',
          'taxPayerNumber',
          'nationalHealthServiceNumber',
          'socialSecurityNumber',
          'nationalIdNumber',
          'gender',
          'address',
          'languageCode',
          'religion',
          'occupationId',
          'region',
          'name',
          'displayName',
          'educationLevel',
          'maritalStatus',
          'isActive',
        ],
      },
      propertiesToInclude: [
        'socialResponses',
        'room',
        'admissionDate',
        'departureDate',
        'processNumber',
        'recurringFee',
        'additionalInfo',
      ],
      entitySocialResponses: {
        propertiesToInclude: ['name', 'abbreviation'],
      },
    },
  });

  return {
    entity,
    reportData,
  };
}

function createSeniorsReportFilters(rawFilters: string | undefined) {
  const filters = createUsersFilters(rawFilters);

  const socialResponseIds = filters.socialResponses;
  const usersActiveStatus =
    filters.activeStatus && filters.activeStatus.length === 1 ? filters.activeStatus[0] : undefined;

  return {
    usersActiveStatus,
    socialResponseIds,
  };
}
